module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#f9f9f9",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "index wrapper_1200",
    attrs: {
      "data-v-7bc497ef": ""
    }
  }, [_c('div', {
    staticClass: "wrapper pact"
  }, [(_vm.picList.length > 0) ? _c('div', {
    staticClass: "slider-banner banner"
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.picList[0].content), function(item, index) {
    return (index < 10) ? _c('swiper-slide', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": item.pic_url
      },
      on: {
        "click": function($event) {
          return _vm.jumpTap(item.url)
        }
      }
    })]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination paginationBanner",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "category acea-row row-middle",
    on: {
      "mouseleave": function($event) {
        return _vm.leave()
      }
    }
  }, [_c('div', {
    staticClass: "sort"
  }, _vm._l((_vm.categoryList), function(item, index) {
    return (index < 10) ? _c('div', {
      key: index,
      staticClass: "item acea-row row-between-wrapper",
      class: index === _vm.current ? 'bg-color' : '',
      on: {
        "mouseenter": function($event) {
          return _vm.enter(index)
        }
      }
    }, [_c('div', {
      staticClass: "name line1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "iconfont icon-you"
    })]) : _vm._e()
  }), 0), _vm._v(" "), (_vm.seen) ? _c('div', {
    staticClass: "sortCon"
  }, [_c('div', {
    staticClass: "erSort acea-row row-top"
  }, _vm._l((_vm.categoryCurrent.children), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item acea-row row-middle",
      on: {
        "click": function($event) {
          return _vm.goCate(_vm.categoryCurrent, item, index)
        }
      }
    }, [_c('div', {
      staticClass: "pictrue"
    }, [(item.pic_url) ? _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (item.pic_url),
        expression: "item.pic_url"
      }]
    }) : _c('img', {
      attrs: {
        "src": require("@/assets/images/no_sort.jpg"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "name line1"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "classify",
    attrs: {
      "data-v-7bc497ef": ""
    }
  }, _vm._l((_vm.pageList), function(pvalue, pindex) {
    return _c('div', {
      key: pindex,
      staticClass: "list",
      attrs: {
        "data-v-7bc497ef": ""
      }
    }, [_c('div', {
      staticClass: "title acea-row row-between-wrapper",
      attrs: {
        "data-v-7bc497ef": ""
      }
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "data-v-7bc497ef": ""
      }
    }, [_vm._v(_vm._s(pvalue.name))])]), _vm._v(" "), _c('div', {
      staticClass: "acea-row row-middle",
      attrs: {
        "data-v-7bc497ef": ""
      }
    }, [_c('div', {
      staticClass: "itemOne",
      attrs: {
        "data-v-7bc497ef": ""
      }
    }, [_c('span', {
      staticClass: "more acea-row row-center-wrapper",
      attrs: {
        "data-v-7bc497ef": "",
        "href": "#"
      }
    }, [_c('img', {
      attrs: {
        "data-v-7bc497ef": "",
        "src": pvalue.content[0].pic_url
      }
    })])]), _vm._v(" "), _vm._l((pvalue.goodsList), function(goodsvalue, goodsindex) {
      return _c('div', {
        key: goodsindex,
        staticClass: "item",
        attrs: {
          "data-v-7bc497ef": ""
        },
        on: {
          "click": function($event) {
            return _vm.jumpTap(goodsvalue.url)
          }
        }
      }, [_c('div', {
        staticClass: "pictrue",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_c('img', {
        attrs: {
          "data-v-7bc497ef": "",
          "src": goodsvalue.goods.pic_url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "money acea-row row-between-wrapper",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_c('div', {
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_c('span', {
        staticClass: "font-color",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_vm._v("¥" + _vm._s(goodsvalue.goods.orig_price))]), _vm._v(" "), _c('span', {
        staticClass: "y_money",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_vm._v("¥" + _vm._s(goodsvalue.goods.price_range[0]))])])]), _vm._v(" "), _c('div', {
        staticClass: "name line2",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_vm._v(_vm._s(goodsvalue.goods.title))]), _vm._v(" "), _c('div', {
        staticClass: "payment acea-row row-between-wrapper",
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_c('span', {
        attrs: {
          "data-v-7bc497ef": ""
        }
      }, [_vm._v(_vm._s(goodsvalue.goods.sold_count + goodsvalue.goods.sold_show_count) + "人付款")])])])
    })], 2)])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a47dc34e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/IndexPc.vue
// module id = 1306
// module chunks = 0